import { createFileRoute } from '@tanstack/react-router';
import { AudiencesSetupRouteView } from '@/pages/workspaces/integrations/audiences/routing';
import { LastWorkspaceResolver } from './-components';

function AudiencesSetupRoute() {
  const { type } = Route.useParams();

  return (
    <LastWorkspaceResolver>
      <AudiencesSetupRouteView type={type} />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/integrations/audiences/$type/setup')({
  component: AudiencesSetupRoute,
});
